import { api, extractApiError } from "@/lib/api";

export interface AgentChatResponse {
  reply: string;
  sessionId: string;
  actionsExecuted?: unknown[] | null;
}

export async function sendAgentMessage(
  sessionId: string,
  message: string,
  pageContext?: Record<string, unknown>,
): Promise<AgentChatResponse> {
  try {
    const { data } = await api.post<AgentChatResponse>("/api/agent/chat", {
      sessionId,
      message,
      pageContext,
    });
    return data;
  } catch (err) {
    throw new Error(extractApiError(err, "Error contactando al agente"));
  }
}
